// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — input.styled.classic.js, новая — input.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './input.styled.classic';
import * as cp from './input.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
